import { addMinutes, format, parseISO } from "date-fns";
import moment from "moment";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { useLocalStorage } from "../../../hooks";
import * as dashboardActions from "../../../redux/reducers/dashboardReducer";
import { dashboardState } from "../../../redux/reducers/dashboardReducer";


import { DateObject, Calendar as MultiCalendar } from "react-multi-date-picker";


import BookingLinkModal from "../../../components/BookingLinkModal";
import ChangeDateTimeModal from "../../../components/ChangeDateTimeModal";
import ChangeLocationModal from "../../../components/ChangeLocationModal";

import { useNavigate } from "react-router-dom";
import copyOrange from "../../../assets/copyOrange.svg";
import defaultImage from "../../../assets/defaultImage.svg";
import dropdownbottom from "../../../assets/dropdownbottom.svg";
import greenlocation from "../../../assets/greenlocation.svg";
import greentime from "../../../assets/greentime.svg";
import menu_schedule from "../../../assets/menu_schedule.svg";
import shareOrange from "../../../assets/shareOrange.svg";
import { TwConfirmDialog, TwContainer, TwDialog, TwMainLayout, TwPopover, TwRadialProgress, TwRating } from "../../../components/tailwind";
import { minutesToDuration } from "../../../helpers";
import { useToast } from "../../../provider/ToastProvider";
import { setGlobalLoading } from "../../../redux/reducers/loadingReducer";
import { userState } from "../../../redux/reducers/userReducer";
import axiosInstance from "../../../utils/axiosInstance";
import { getUrlForClasses } from "../../../utils/confighelpers";
import AddClassParticipantForm from "./AddClassParticipantForm";
import SessionBooking from "./SessionBooking";

export default function BusinessProfileClassSession({ navigation }) {

  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const dispatch = useDispatch();
  const dashboardReduxState = useSelector(dashboardState);
  const userReduxState = useSelector(userState);
  const [userToken] = useLocalStorage("userToken");
  const navigate = useNavigate();
  const [isDescExpanded, setDescExpanded] = React.useState(false);
  const [backState, setBackState] = React.useState(0);
  const [dataToDisplay] = React.useState(dashboardReduxState.calendarClassData || {});
  const [sessionDataToDisplay, setSessionDataToDisplay] = React.useState(dashboardReduxState.calendarSessionData || {});


  React.useEffect(() => {
    (async () => {
      const isPckg = dashboardReduxState?.calendarClassData?.isPackage || false;
      const config = {
        method: "get",
        url: `${getUrlForClasses()}getScheduleDetail?scheduleclassId=${dashboardReduxState.calendarSessionId}&isPackage=${isPckg}&onlySingleSchedule=true`,
      };
      dispatch(setGlobalLoading(true));
      const request = await axiosInstance(config);
      dispatch(setGlobalLoading(false));
      if (request.status === 200) {
        if (request.data.statusCode === 200) {
          dispatch(dashboardActions.setCalendarClassData(request.data.data));
          dispatch(dashboardActions.setCalendarSessionData(request.data.data));
          setSessionDataToDisplay(request.data.data);
          if (request.data.data.classDate) {
            await getMyClubSchedule(request.data.data);
          }
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dashboardReduxState.updateSessionComp]);

  const handleBackToHome = () => {
    dispatch(dashboardActions.setCalendarSessionId(-1));
    dispatch(dashboardActions.setCalendarClassData({}));
    dispatch(dashboardActions.setCalendarSessionData({}));
    dispatch(dashboardActions.setViewSessionPage(false));
    dispatch(dashboardActions.setCalendarOpen(false));
    navigation("/home/dashboard");
  };
  const [isWhatToCarryExpanded, setWhatToCarryExpanded] = React.useState(false);
  const [courseStartDate, setCourseStartDate] = React.useState(new Date());
  const [bookingDetails, setBookingDetails] = React.useState({
    bookedPeople: [],
    seats: 0,
    seatsBooked: 0,
    seatsBookedPerc: 0,
  });
  const [dateTimeModalOpen, setDateTimeModalOpen] = React.useState(false);
  const [locationModalOpen, setLocationModalOpen] = React.useState(false);
  const [bookingLinkModalOpen, setBookingLinkModalOpen] = React.useState(false);
  const [participantFormOpen, setParticipantFormOpen] = React.useState(false);
  const [openCancelModal, setOpenCancelModal] = React.useState(false);
  const [classDates, setClassDates] = React.useState([]);
  const [recentBookingsList, setRecentBookingsList] = React.useState([]);
  const [openCalenderTime, setOpenCalenderTime] = React.useState(false);
  const [scheduleTimeList, setScheduleTimeList] = React.useState([]);
  const [allClassSchedulesList, setAllClassSchedulesList] = React.useState([]);
  const appUrl = sessionDataToDisplay?.appUrl ? sessionDataToDisplay?.appUrl : "https://www.bookings.bookzy.me/";
  const bookingLink = appUrl + (sessionDataToDisplay?.classId?.bookingLink ? sessionDataToDisplay?.classId?.bookingLink : "");

  const [popoverOptionsDisabled, setPopoverOptionsDisabled] =
    React.useState(false);

  React.useEffect(() => {
    const today = Date.now();
    const { classDate, duration, classEndDate, participants, capacity } =
      sessionDataToDisplay;
    const parsedStartDate = parseISO(classDate);
    setCourseStartDate(parsedStartDate);
    const endTime = addMinutes(parsedStartDate, duration);
    // const parsedEndDate = parseISO(classEndDate);
    const startDateFormat = "d MMM, EEE, hh:mmaa";
    const endDateFormat = "hh:mmaa";

    // if (sessionDataToDisplay?.isPackage) {
    const { daysInWeek, allClassSchedules, scheduleClassBookings } = sessionDataToDisplay;
    /* if (daysInWeek) {
      const mapDays = daysInWeek.map((day) => parseISO(day));
      setCourseDates([...mapDays]);
    } */
    if (allClassSchedules) {
      setAllClassSchedulesList(allClassSchedules)
      const mapDays = allClassSchedules.map((data) => parseISO(data.classDate));
      setClassDates([...mapDays]);
    }
    if (scheduleClassBookings) {
      setRecentBookingsList(scheduleClassBookings);
    }

    // if (isBefore(parsedStartDate, today) || (sessionDataToDisplay?.eventStatus && [/* 'Draft', 'Published',  */'cancelled', 'refunded'].indexOf(sessionDataToDisplay?.eventStatus?.toLowerCase()) > -1)) {
    // if (moment(classDate).subtract({ hours: 3 }).isBefore() || (sessionDataToDisplay?.eventStatus && [/* 'Draft', 'Published',  */'cancelled', 'refunded'].indexOf(sessionDataToDisplay?.eventStatus?.toLowerCase()) > -1)) {
    if (moment(classDate).isBefore() || (sessionDataToDisplay?.eventStatus && [/* 'Draft', 'Published',  */'cancelled', 'refunded'].indexOf(sessionDataToDisplay?.eventStatus?.toLowerCase()) > -1)) {
      setPopoverOptionsDisabled(true);
    }

    let ticketQty = 0;
    let ticketsBooked = 0;
    // scheduleClass.scheduleClassBookings
    if (sessionDataToDisplay?.eventPricingList && sessionDataToDisplay?.eventPricingList.length > 0) {
      sessionDataToDisplay?.eventPricingList.map((booking) => {
        ticketQty = parseInt(ticketQty) + parseInt(booking.capacity);
        ticketsBooked = parseInt(ticketsBooked) + parseInt(booking?.ticketsBooked ? booking.ticketsBooked.ticketsBookedConfirmed : 0);
      })
    } else {
      if (sessionDataToDisplay?.scheduleClassBookings && sessionDataToDisplay?.scheduleClassBookings.length > 0) {
        ticketQty = capacity;
        sessionDataToDisplay?.scheduleClassBookings.map((booking) => {
          if (booking.status === "Cancelled") {
            return booking;
          }
          if (booking.ticketsBought && booking.ticketsBought.length > 0) {
            booking.ticketsBought.map((ticket) => {
              ticketsBooked = parseInt(parseInt(ticketsBooked) + parseInt(ticket.bookingQty))
            })
          } else {
            ticketsBooked = parseInt(ticketsBooked) + parseInt(booking.capacity ? booking.capacity : 0);
          }
        })
      }
    }

    /* setBookingDetails((prevState) => ({
      ...prevState,
      bookedPeople: participants,
      seats: capacity,
      seatsBooked: ticketQty,
      seatsBookedPerc: (ticketQty / capacity) * 100,
    })); */
    setBookingDetails((prevState) => ({
      ...prevState,
      bookedPeople: participants,
      seats: ticketQty,
      seatsBooked: ticketsBooked,
      seatsBookedPerc: (ticketsBooked / ticketQty) * 100,
    }));
  }, [sessionDataToDisplay]);

  const handleDateTimeModalOpen = () => setDateTimeModalOpen(true);
  const handleDateTimeModalClose = () => setDateTimeModalOpen(false);

  const handleLocationModalOpen = () => setLocationModalOpen(true);
  const handleLocationModalClose = () => setLocationModalOpen(false);

  const handleBookingLinkModalOpen = () => { setBookingLinkModalOpen(true); }
  const handleBookingLinkModalClose = () => setBookingLinkModalOpen(false);

  const handleParticpantFormOpen = () => setParticipantFormOpen(true);
  const handleParticipantFormClose = () => setParticipantFormOpen(false);

  const handleOpenCancelModal = () => setOpenCancelModal(true);
  const handleCloseCancelModal = () => setOpenCancelModal(false);

  const handleCancelSession = async () => {
    const data = {
      scheduleId: sessionDataToDisplay?.instanceId,
      isPackage: sessionDataToDisplay?.isPackage,
    };
    dispatch(setGlobalLoading(true));
    const result = await axiosInstance.delete(
      `${getUrlForClasses()}deleteScheduleTheClass`,
      {
        data,
      }
    );
    dispatch(setGlobalLoading(false));
    if (result.data.statusCode === 200) {
      addSuccessToast("Cancelled Successfully");
      dispatch(dashboardActions.setCalendarSessionId(-1));
      dispatch(dashboardActions.setCalendarOpen(false));
      navigate("/home/dashboard");
    } else {
      addErrorToast(result.data.message);
    }
  };

  const [cancelText, setCancelText] = React.useState("Cancel Class");

  const onCancel = async () => {
    if (!dataToDisplay.isPackage) {
      setCancelText(
        "Canceling this class will refund respective fee for all the participants if already paid.              Are you sure you want to cancel this class"
      );
      handleOpenCancelModal();
    } else {
      addErrorToast("You cannot cancel single session of this course");
    }
  };

  const handleSessionClick = async (id) => {
    if (dashboardReduxState.calendarSessionId === id) {
      dispatch(dashboardActions.setCalendarSessionId(-1));
      dispatch(dashboardActions.setCalendarOpen(false));
      navigate("/home/dashboard");
      return;
    }
    addToast("Loading session details");
    const isPckg = sessionDataToDisplay?.isPackage || false;
    const config = {
      method: "get",
      url: `${getUrlForClasses()}getScheduleDetail?scheduleclassId=${id}&isPackage=${isPckg}`,
    };
    dispatch(setGlobalLoading(true));
    const request = await axiosInstance(config);
    dispatch(setGlobalLoading(false));
    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        // dispatch(dashboardActions.setCalendarClassData(classData));
        dispatch(dashboardActions.setCalendarSessionId(id));
        dispatch(dashboardActions.setCalendarSessionData(request.data.data));
        dispatch(dashboardActions.setViewSessionPage(true));
        // navigate("/myschedule/detail");
        window.location.reload();
      }
    }
  };

  const ticketBought = (scheduleClass, row) => {
    let ticketQty = 0;
    // scheduleClass.scheduleClassBookings
    if (scheduleClass.scheduleClassBookings && scheduleClass.scheduleClassBookings.length > 0) {
      scheduleClass.scheduleClassBookings.map((booking) => {
        if (booking.status === "Cancelled") {
          return booking;
        }
        if (booking.ticketsBought && booking.ticketsBought.length > 0) {
          booking.ticketsBought.map((ticket) => {
            if (ticket.ticketType === row.ticketType) {
              ticketQty = parseInt(parseInt(ticketQty) + parseInt(ticket.bookingQty))
            }
          })
        } else {
          ticketQty = parseInt(ticketQty) + parseInt(booking.capacity ? booking.capacity : 0);
        }
      })
    }
    return ticketQty;
  }

  const onBackClick = () => {
    if (backState === 0) {
      navigate("/myclasses/myschedule", { replace: true });
    } else {
      setBackState(0);
    }
  };

  const getMyClubSchedule = async (sessionData) => {
    const config = {
      method: "get",
      // url: `${getUrlForClasses()}groupScheduledClass?searchDate=${newDate}&classId=${classData?.id || ""}`,
      url: `${getUrlForClasses("")}getMyClubSchedule?searchDate=${sessionData?.classDate}&classId=${sessionData?.classId._id || sessionData?.classId || ""}&businessId=${userReduxState.userData._id}&daysbeforeCurrentDate=7&daysAfterCurrentDate=90`,
    };
    const request = await axiosInstance(config);
    let selectedDateSessions;
    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        selectedDateSessions = request.data.data;
        if (Object.keys(selectedDateSessions).length > 0) {
          setClassDates([]);
          let mapDays = []
          let allClassSchedules = []
          Object.keys(selectedDateSessions).map((d) => {
            if (selectedDateSessions[d].length > 0) {
              allClassSchedules.push(...selectedDateSessions[d])
              mapDays.push(selectedDateSessions[d].map((data) => parseISO(data.classDate)));
              // console.log("mapDays", mapDays);
              // setClassDates([...classDates, ...mapDays]);
            }
            return d;
          })
          setAllClassSchedulesList(allClassSchedules)
          // setClassDates([...mapDays]);
        }
      }
    }
    // console.log("selectedDateSessions", selectedDateSessions);

  };
  React.useEffect(() => {
    if (allClassSchedulesList.length > 0) {
      const mapDays = (allClassSchedulesList.map((data) => parseISO(data.classDate)));
      // console.log("mapDays", mapDays);
      // setClassDates([...classDates, ...mapDays]);
      setClassDates([...mapDays]);
    }
  }, [allClassSchedulesList]);

  // console.log("allClassSchedulesList", allClassSchedulesList);
  // console.log("classDates", classDates);
  // console.log("sessionDataToDisplay", sessionDataToDisplay);

  return (
    <TwMainLayout
      headTitle={`${dashboardReduxState.calendarClassData.className} ${backState == 1 ? " | Bookings" : ""}`}
      breadcrumbs={[
        { title: "Schedule", onClick: () => { onBackClick(); } },
        { title: `${dashboardReduxState.calendarClassData.className} ${backState == 1 ? " | Bookings" : ""}` },
      ]}
      children={
        <TwContainer
          className=""
        >
          {/* <div className={"max-w-3xl"}> */}
          <div className={""}>
            <>
              <div className="flex flex-col w-full">
                <div className="flex flex-col gap-3 w-full">
                  <div className="flex flex-col sm:flex-row gap-5">
                    <div className="flex flex-auto flex-col gap-2">
                      <div className={"w-full h-44 md:h-72 flex justify-center"}>
                        {dataToDisplay.classPhoto ? (
                          <img
                            className={
                              // "w-full h-[283px] object-cover object-fill rounded-2xl"
                              "sm:h-60 lg:h-72 rounded-2xl"
                            }
                            src={dataToDisplay.classPhoto}
                            alt={""}
                          />
                        ) : (<img
                          className={
                            "w-full sm:h-60 lg:h-72 object-cover rounded-2xl"
                          }
                          src={defaultImage}
                          alt={""}
                        />)}
                      </div>
                      <div className={"grow"}>
                        <h2 className={"font-bold text-xl md:text-3xl text-brown-coffee"}>
                          {dataToDisplay.className}
                        </h2>
                        <p className={"text-sm md:text-base"}>
                          {dataToDisplay?.classId?.tagLines}
                        </p>
                        {(dataToDisplay.scheduleName !== "") ? (<h4 className={"font-bold text-base md:text-xl text-portland-orange"}>{dataToDisplay.scheduleName}</h4>) : ""}
                        <div
                          className={
                            "min-w-40 flex gap-2 items-left bg-white rounded-lg"
                          }
                        >
                          <TwRating
                            rating={dataToDisplay?.classId?.rating}
                          />
                        </div>
                        <p className={"text-[15.35px] text-[#FF4040]"}> {(sessionDataToDisplay?.eventStatus && [/* 'Draft', 'Published',  */'cancelled', 'refunded'].indexOf(sessionDataToDisplay?.eventStatus?.toLowerCase()) > -1) ? "This Class instance is cancelled" : ""}</p>
                        <div className="hidden flex flex-col justify-start w-full mt-5">
                          <p className={"text-base"}>Share the link below to let your customer book</p>
                          <div className="flex justify-center items-center w-full mt-5 bg-list-hover rounded-2xl border border-gray-300">
                            <div className="max-h-6 flex-1 pl-2 text-black my-0 mx-5 truncate cursor-pointer"
                              onClick={() => {
                                navigator.clipboard.writeText(bookingLink);
                                addSuccessToast("Copied!");
                              }}
                            >
                              {bookingLink}
                            </div>
                            <div className="flex flex-none bg-brown-coffee py-2 px-5 rounded-e-2xl">
                              <button className="cursor-pointer" type="button" underline="none" onClick={() => {
                                navigator.clipboard.writeText(bookingLink);
                                addSuccessToast("Copied!");
                              }}>
                                <img
                                  className={"w-7"}
                                  src={copyOrange}
                                  alt={""}
                                />
                              </button>
                              <button className="cursor-pointer" type="button" underline="none" target="_blank" onClick={() => {
                                window.open(bookingLink, '_blank');
                              }}>
                                <img
                                  className={"w-7 ml-3 mr-3"}
                                  src={shareOrange}
                                  alt={""}
                                />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-auto flex-col gap-6 justify-center items-left ">
                      <div className="flex justify-center items-center md:w-4/5">
                        <div className="flex-none">
                          <img
                            className={""}
                            src={greenlocation}
                            alt={""}
                          />
                        </div>
                        <div className="flex-1 pl-2">
                          <div className="text-gray-500 text-sm">Where </div>
                          <div className="text-black text-base">
                            <p className="font-bold">{sessionDataToDisplay && sessionDataToDisplay?.location ? sessionDataToDisplay?.location.addressName : ""}</p>
                            <p>{sessionDataToDisplay && sessionDataToDisplay?.location ? sessionDataToDisplay?.location.address : ""}</p>
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-center items-center md:w-4/5">
                        <div className="flex-none">
                          <img
                            className={""}
                            src={greentime}
                            alt={""}
                          />
                        </div>
                        <div className="flex-1 pl-2">
                          <div className="text-gray-500 text-sm">When </div>
                          <div className="text-black text-base">
                            {sessionDataToDisplay?.classDate ? format(parseISO(sessionDataToDisplay?.classDate), "EEEE, MMMM d 'at' HH:mm") + " - " + format(parseISO(sessionDataToDisplay?.classEndDate), "HH:mm") : ""}
                          </div>
                          <div className="text-gray-500 text-xs">
                            {allClassSchedulesList && allClassSchedulesList.length > 1 ? "This Class has multiple instances" : ""}
                          </div>
                        </div>
                      </div>
                      <div className="flex py-3 gap-3">
                        <div className="flex-1 sm:flex-none">
                          <TwPopover
                            buttonClassName={"bg-blue-bz text-white rounded-lg w-full sm:w-40 p-3"}
                            buttonContent={(<span className={"flex flex-row items-center"}>
                              <p className={"w-full"}>Actions</p>
                              <img src={dropdownbottom} alt={""} />
                            </span>)}
                          >
                            <div className={"flex flex-col divide-y divide-gray-200"}>
                              <button
                                disabled={popoverOptionsDisabled}
                                onClick={() => {
                                  handleDateTimeModalOpen();
                                }}
                                className={`hover:bg-gray-200 p-4 text-sm text-left text-light-brown-coffee disabled:text-lilac`}
                              >
                                Change Schedule
                              </button>
                              <button
                                disabled={popoverOptionsDisabled}
                                onClick={() => {
                                  handleLocationModalOpen();
                                }}
                                className={`hover:bg-gray-200 p-4 text-sm text-left text-light-brown-coffee disabled:text-lilac`}
                              >
                                Update Location
                              </button>
                              <button
                                // disabled={popoverOptionsDisabled}
                                disabled={(sessionDataToDisplay?.eventStatus && ['cancelled', 'refunded'].indexOf(sessionDataToDisplay?.eventStatus?.toLowerCase()) > -1)}
                                // disabled={true}
                                onClick={() => {
                                  handleParticpantFormOpen();
                                }}
                                className={`hover:bg-gray-200 p-4 text-sm text-left text-light-brown-coffee disabled:text-lilac`}
                              >
                                Add Participant
                              </button>
                              {/* <button disabled={popoverOptionsDisabled} onClick={onCancel}
                                className={`hover:bg-gray-200 p-4 text-sm text-left text-light-brown-coffee disabled:text-lilac`}>
                                Cancel
                              </button> */}
                              <button
                                disabled={popoverOptionsDisabled}
                                // onClick={onClickShareLink}
                                onClick={handleBookingLinkModalOpen}
                                className={`hover:bg-gray-200 p-4 text-sm text-left text-light-brown-coffee disabled:text-lilac`}
                              >
                                Share Booking Link
                              </button>
                              <button
                                disabled={popoverOptionsDisabled}
                                onClick={onCancel}
                                className={`hover:bg-gray-200 p-4 text-sm text-left text-light-brown-coffee disabled:text-lilac`}
                              >
                                Cancel Class
                              </button>
                            </div>
                          </TwPopover>
                        </div>
                        {classDates && classDates.length > 1 && allClassSchedulesList && allClassSchedulesList.length > 1 ? (<div className="flex flex-col justify-start items-left">

                          <div className="flex-none flex w-full">
                            <TwPopover
                              buttonClassName={"bg-portland-orange text-white rounded-lg w-full sm:w-auto p-3 px-3 sm:px-6"}
                              buttonContent={(<span className={"flex flex-row gap-2 sm:gap-4 items-center"}>
                                <img src={menu_schedule} alt={""} />
                                <p className={"w-auto truncate"}>Pick another instance</p>
                                <img src={dropdownbottom} alt={""} />
                              </span>)}
                            >
                              <div className="flex-none">
                                <MultiCalendar
                                  className="bookzy-calendar preview-click px-2.5 py-1"
                                  currentDate={new DateObject(sessionDataToDisplay?.classDate)}
                                  weekDays={["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]}
                                  // readOnly
                                  single
                                  onChange={(dates) => {
                                    const dateTransformed = moment(dates.toDate()).format("MM/DD/YYYY");
                                    const selectedDatesTransformed = classDates ? classDates.map(
                                      (day) => moment(day).format("MM/DD/YYYY")
                                    ) : [];
                                    let selectindex = selectedDatesTransformed.indexOf(dateTransformed);
                                    /** For schedule Time List start **/
                                    // let scheduleTimeLists = sessionDataToDisplay?.allClassSchedules
                                    let scheduleTimeLists = allClassSchedulesList
                                      .filter(o => moment(o.classDate).format("MM/DD/YYYY") == (moment(dateTransformed).format("MM/DD/YYYY")));

                                    setScheduleTimeList(scheduleTimeLists)
                                    setOpenCalenderTime(true)
                                    /** For schedule Time List end **/

                                    // if (selectindex > -1) {
                                    //   if (!moment(dateTransformed).isSame(moment(sessionDataToDisplay?.classDate).format("MM/DD/YYYY"))) {
                                    //     console.log("not same");
                                    //     console.log(sessionDataToDisplay?.allClassSchedules[selectindex]);
                                    //     // handleSessionClick(sessionDataToDisplay?.allClassSchedules[selectindex]._id);
                                    //   } else { console.log("same"); }
                                    // }

                                    // // setCourseDates([...courseDates]);
                                    // // handleSessionClick();
                                    return false;
                                  }}
                                  mapDays={({
                                    date,
                                    today,
                                    selectedDate,
                                    currentMonth,
                                    isSameDate,
                                  }) => {
                                    let props = {};

                                    // const dateTransformed = date.toDate();
                                    const dateTransformed = moment(date.toDate()).format("MM/DD/YYYY");
                                    /* const selectedDatesTransformed = selectedDate ? selectedDate.map(
                                      // (day) => day.toDate()
                                      (day) => moment(day.toDate()).format("MM/DD/YYYY")
                                    ) : []; */
                                    const selectedDatesTransformed = classDates ? classDates.map(
                                      // (day) => day.toDate()
                                      (day) => moment(day).format("MM/DD/YYYY")
                                    ) : [];
                                    // console.log(moment(date.toDate()).format("MM/DD/YYYY") + "===" + moment(today).format("MM/DD/YYYY") + "= " + (moment(moment(date.toDate()).format("MM/DD/YYYY")).isSame(moment(today).format("MM/DD/YYYY"))));
                                    // console.log("isSameDate", isSameDate);
                                    // console.log("dateTransformed", dateTransformed + " ==  " + selectedDatesTransformed.indexOf(dateTransformed));
                                    // console.log("selectedDatesTransformed", selectedDatesTransformed);
                                    /* if (moment(moment(date.toDate()).format("MM/DD/YYYY")).isSame(moment(today).format("MM/DD/YYYY"))) {
                                      props.className = "default-current-date";
                                    } */

                                    if (selectedDatesTransformed.indexOf(dateTransformed) > -1) {
                                      props.className = "default-class-dates";
                                    }

                                    if (moment(moment(date.toDate()).format("MM/DD/YYYY")).isSame(moment(sessionDataToDisplay?.classDate).format("MM/DD/YYYY"))) {
                                      props.className = "default-selected-date";
                                    }

                                    return props;
                                  }}
                                />
                                {openCalenderTime && (<TwDialog
                                  dialogTitle={"Schedule Time"}
                                  dialogOpen={openCalenderTime}
                                  onClose={(v) => { setOpenCalenderTime(false) }}
                                >
                                  <div className="flex flex-col w-full  gap-2">
                                    <div className="flex flex-col gap-2">
                                      {scheduleTimeList.length > 0 && scheduleTimeList.map((d) => {
                                        let durationObj = minutesToDuration(d.duration)
                                        let ticketQty = 0;
                                        let ticketsBooked = 0;
                                        if (d?.eventPricingList && d.eventPricingList.length > 0) {
                                          d.eventPricingList.map((booking) => {
                                            ticketQty = parseInt(ticketQty) + parseInt(booking.capacity);
                                            // ticketsBooked = parseInt(ticketsBooked) + parseInt(booking?.ticketsBooked ? booking.ticketsBooked.ticketsBookedConfirmed : 0);
                                          })
                                          if (d.scheduleClassBookings && d.scheduleClassBookings.length > 0) {
                                            ticketQty = d.capacity;
                                            d.scheduleClassBookings.map((booking) => {
                                              if (booking.status === "Cancelled") {
                                                return booking;
                                              }
                                              if (booking.ticketsBought && booking.ticketsBought.length > 0) {
                                                booking.ticketsBought.map((ticket) => {
                                                  ticketsBooked = parseInt(parseInt(ticketsBooked) + parseInt(ticket.bookingQty))
                                                })
                                              } else {
                                                ticketsBooked = parseInt(ticketsBooked) + parseInt(booking.capacity ? booking.capacity : 0);
                                              }
                                            })
                                          } else if (d.participants && d.participants.length > 0) {
                                            ticketQty = d.capacity;
                                            d.participants.map((booking) => {
                                              if (booking.status === "Cancelled") {
                                                return booking;
                                              }
                                              if (booking.ticketsBought && booking.ticketsBought.length > 0) {
                                                booking.ticketsBought.map((ticket) => {
                                                  ticketsBooked = parseInt(parseInt(ticketsBooked) + parseInt(ticket.bookingQty))
                                                })
                                              } else {
                                                ticketsBooked = parseInt(ticketsBooked) + parseInt(booking.capacity ? booking.capacity : 0);
                                              }
                                            })
                                          }
                                        }
                                        return (
                                          <div className="flex flex-row items-top gap-4 grow p-2 cursor-pointer bg-white hover:bg-[#e1e1e1] shadow-md border border-bright-gray rounded-2xl"
                                            onClick={() => {
                                              setOpenCalenderTime(false);
                                              handleSessionClick(d._id);
                                            }}>
                                            <div
                                              className=""
                                            >
                                              <img
                                                className={`${"w-[100px] max-w-[100px] h-[100px] rounded-xl"
                                                  } object-fill`}
                                                src={dataToDisplay?.classPhoto || ""}
                                                alt={"session img"}
                                              />
                                            </div>
                                            <div className={`flex item-top grow`}>
                                              <div className={`flex flex-col item-center w-full gap-1`}>
                                                <h3
                                                  className={`text-black font-bold text-base`}
                                                >
                                                  {dataToDisplay?.className}
                                                </h3>
                                                <div
                                                  className={`text-black text-xs rounded-full`}
                                                >
                                                  {d.classDate ? format(parseISO(d.classDate), "EEEE, MMMM d 'at' hh:mm aa") + " - " + format(parseISO(d.classEndDate), "hh:mm aa") : ""}
                                                  {" • "}
                                                  {(d.duration > 60) ? `${durationObj.hours} hr ${durationObj.mins} min` : `${d.duration} minutes`}
                                                </div>
                                                <div
                                                  className={`text-[#A1A1A1] text-xs rounded-full`}
                                                >
                                                  {d.location.address}
                                                </div>
                                                <div
                                                  className={`text-[#A1A1A1] text-xs rounded-full`}
                                                >
                                                  {ticketsBooked}/{ticketQty} Participants
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      })}
                                    </div>
                                  </div>
                                </TwDialog>)}
                              </div>
                            </TwPopover>
                          </div>
                        </div>) : ""}
                      </div>
                    </div>
                  </div>
                  <div className="mt-10 p-2 border-2 border-gray-200 rounded-xl w-full md:w-8/12 xl:w-6/12">
                    <div className="grid grid-cols-2 gap-3">
                      <div
                        className={
                          "min-w-[182.74px] h-[105px] bg-white rounded-xl flex flex-col gap-4 cursor-pointer border-0 border-gray-200"
                        }
                      >
                        <p className={"font-semibold text-sm text-brown-coffee"}>
                          Overall Bookings Status
                        </p>
                        {Array.isArray(bookingDetails.bookedPeople) &&
                          bookingDetails.bookedPeople && bookingDetails.bookedPeople.length > 3 ? (
                          <div
                            className={`flex flex-row items-center -space-x-2 overflow-hidden`}
                          >
                            {bookingDetails.bookedPeople.slice(0, 3).map((person, i) => (
                              <div className='avatar' key={i}>
                                <div className='flex-none'>
                                  <img
                                    src={person.profilePic}
                                    alt={person.fullName}
                                    title={person.fullName}
                                    className='rounded-full size-6 sm:size-8'
                                  />
                                </div>
                              </div>
                            ))}
                            <div className='avatar placeholder'>
                              <div
                                className={`flex justify-center items-center rounded-full font-semibold text-xs size-6 bg-brown-coffee text-white border-2 border-white`}
                              >
                                <span>
                                  +
                                  {bookingDetails.bookedPeople.length - 3}
                                </span>
                              </div>
                            </div>
                          </div>
                        ) : bookingDetails.bookedPeople && bookingDetails.bookedPeople.length < 4 ? (
                          <div
                            className={`flex flex-row items-center -space-x-2 overflow-hidden`}
                          >
                            {bookingDetails.bookedPeople.map((person) => (
                              <div className='avatar' key={person.userId}>
                                <div className='flex-none'>
                                  <img
                                    src={person.profilePic}
                                    alt={person.fullName}
                                    title={person.fullName}
                                    className='rounded-full size-6 sm:size-8 bg-black'
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                      <div
                        className={
                          "min-w-[182.74px] h-[105px] p-4 bg-white rounded-xl flex flex-row justify-end gap-2 sm:gap-8 border-0 border-gray-200"
                        }
                      >
                        <TwRadialProgress progress={bookingDetails.seatsBookedPerc} />
                        <div>
                          <p
                            className={
                              "font-medium text-granite-gray text-xs text-center"
                            }
                          >
                            Seats Booked
                          </p>
                          <div className={"grid place-items-end"}>
                            <h3
                              className={
                                "text-light-brown-coffee font-bold text-base sm:text-sm md:text-sm lg:text-sm"
                              }
                            >
                              {bookingDetails.seatsBooked}/{bookingDetails.seats}
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <p className={"font-semibold text-base text-brown-coffee"}>
                        Bookings by ticket type
                      </p>
                      <div
                        className="p-2 sm:p-4 mt-2 bg-list-hover rounded-2xl">
                        <table className="min-w-full divide-y divide-gray-300">
                          <thead className="">
                            <tr className="text-center">
                              <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-base font-extrabold text-gray-900 sm:pl-6">
                                Pricing Type
                              </th>
                              <th scope="col" className="px-3 py-3.5 text-center text-base font-extrabold text-gray-900">
                                Price
                              </th>
                              <th scope="col" className="px-3 py-3.5 text-center text-base font-extrabold text-gray-900">
                                Seats Booked
                              </th>
                            </tr>
                          </thead>
                          <tbody className="divide-y-8 !border-y-0 divide-list-hover ">
                            {sessionDataToDisplay?.eventPricingList && [...sessionDataToDisplay?.eventPricingList].map((row, i) => (
                              <tr key={i} className="">
                                <td className="bg-white whitespace-nowrap px-3 py-4 text-center text-base rounded-l-2xl truncate"><div>{row.ticketType}</div></td>
                                <td className="bg-white whitespace-nowrap px-3 py-4 text-center text-base"><div>€{row.amount}</div></td>
                                <td className="bg-white whitespace-nowrap px-3 py-4 text-center text-base rounded-r-2xl"><div>{row.ticketsBooked?.ticketsBookedConfirmed ? row.ticketsBooked.ticketsBookedConfirmed : ticketBought(sessionDataToDisplay, row)}/{row.capacity}</div></td>
                              </tr>
                            ))}

                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className={"flex flex-row justify-end p-1"}>
                    <button className="hidden text-[#5265FF] cursor-pointer" type="button" underline="none" onClick={() => setBackState(true)}>Goto All bookings</button>
                  </div>
                  {false ? (
                    <div className={"flex flex-col gap-5"}>
                      <div className="">
                        <h4 className={"font-bold text-lg text-brown-coffee"}>
                          Description
                        </h4>
                        <p className={"font-light text-base"}>
                          {(
                            dataToDisplay.classId?.description > 175 ? (
                              !isDescExpanded ? (
                                <>
                                  {dataToDisplay.classId?.description.slice(0, 175)}
                                  <span
                                    className={
                                      "text-gray-400 font-light text-base cursor-pointer"
                                    }
                                    onClick={() => setDescExpanded(true)}
                                  >
                                    ...see more
                                  </span>
                                </>
                              ) : (
                                <span>
                                  {dataToDisplay.classId?.description}
                                  <br />
                                  <span
                                    className={
                                      "text-gray-400 font-light text-base cursor-pointer"
                                    }
                                    onClick={() => setDescExpanded(false)}
                                  >
                                    see less
                                  </span>
                                </span>
                              )
                            ) : (
                              <span>{dataToDisplay.classId?.description}</span>
                            )
                          )}
                        </p>
                      </div>
                      <div>
                        <h4 className={"font-bold text-lg text-brown-coffee"}>
                          What To Carry
                        </h4>
                        <p className={"font-light text-base"}>
                          {(
                            dataToDisplay.classId?.whatToCarry?.length > 175 ? (
                              !isWhatToCarryExpanded ? (
                                <>
                                  {dataToDisplay.classId?.whatToCarry?.slice(0, 175)}
                                  <span
                                    className={
                                      "text-gray-400 font-light text-base cursor-pointer"
                                    }
                                    onClick={() => setWhatToCarryExpanded(true)}
                                  >
                                    ...see more
                                  </span>
                                </>
                              ) : (
                                <span>
                                  {dataToDisplay.classId?.whatToCarry}
                                  <br />
                                  <span
                                    className={
                                      "text-gray-400 font-light text-base cursor-pointer"
                                    }
                                    onClick={() => setWhatToCarryExpanded(false)}
                                  >
                                    see less
                                  </span>
                                </span>
                              )
                            ) : (
                              <span>{dataToDisplay.classId?.whatToCarry}</span>
                            )
                          )}
                        </p>
                      </div>
                      <div>
                        <h4 className={"font-bold text-lg text-brown-coffee"}>
                          Cancelation Policy
                        </h4>
                        {(
                          dataToDisplay.classId?.classCancelationPolicy?.isEnabled ? (
                            <p className={"font-light text-base"}>
                              Cancelation is free in case booking is cancelled{" "}
                              <span className={"font-bold"}>
                                {dataToDisplay?.classId?.classCancelationPolicy.text}
                              </span>{" "}
                              before start of the class.
                            </p>
                          ) : (
                            <p className={"font-light text-base"}>
                              No Cancelation Policy available.
                            </p>
                          )
                        )}
                      </div>
                    </div>
                  ) : ""}
                </div>
                <div>
                  <SessionBooking
                    sessionDataToDisplay={sessionDataToDisplay}
                    displayHeader={false}
                  />
                </div>
              </div>
              <AddClassParticipantForm
                open={participantFormOpen}
                handleClose={handleParticipantFormClose}
                isPackage={dataToDisplay.isPackage}
                scheduleDetail={sessionDataToDisplay}
                scheduleId={
                  dataToDisplay.isPackage
                    ? sessionDataToDisplay?.packageId
                    : sessionDataToDisplay?.instanceId
                }
                handleUpdate={() =>
                  dispatch(
                    dashboardActions.setUpdateSessionComp(
                      dashboardReduxState.updateSessionComp + 1
                    )
                  )
                }
              />
              <ChangeDateTimeModal
                open={dateTimeModalOpen}
                handleClose={handleDateTimeModalClose}
                sessionData={sessionDataToDisplay}
                instanceId={sessionDataToDisplay.instanceId}
                handleUpdate={() =>
                  dispatch(
                    dashboardActions.setUpdateSessionComp(
                      dashboardReduxState.updateSessionComp + 1
                    )
                  )
                }
              />
              <ChangeLocationModal
                open={locationModalOpen}
                handleClose={handleLocationModalClose}
                sessionData={sessionDataToDisplay}
                instanceId={sessionDataToDisplay.instanceId}
                handleUpdate={() =>
                  dispatch(
                    dashboardActions.setUpdateSessionComp(
                      dashboardReduxState.updateSessionComp + 1
                    )
                  )
                }
              />

              <TwConfirmDialog
                dialogOpen={openCancelModal}
                dialogType="warning"
                dialogTitle="Cancel Session"
                dialogMessage={cancelText}
                onClose={async () => {
                  handleCloseCancelModal();
                }}
                onConfirm={async () => {
                  handleCancelSession()
                }}
              />
              <BookingLinkModal
                title={"Booking Link for " + dataToDisplay?.className}
                subtitle="Booking Link Generated"
                open={bookingLinkModalOpen}
                handleClose={handleBookingLinkModalClose}
                bookingLink={bookingLink}
              />
            </>
          </div>
        </TwContainer>} />
  );
}
